import React, { useState } from 'react';
import { Shield, BadgeCheck, Award, ChevronDown } from 'lucide-react';
import { certifications } from '../mockData';

const iconMap = {
  Shield: Shield,
  BadgeCheck: BadgeCheck,
  Award: Award
};

const SafetyLab = () => {
  const [expandedId, setExpandedId] = useState(null);
  const [showLeadPopup, setShowLeadPopup] = useState(false);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <section id="safety-lab" className="safety-lab-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">The Safety Lab</h2>
          <p className="section-subtitle">
            Understanding the certifications that protect you on every ride
          </p>
        </div>

        <div className="certifications-grid">
          {certifications.map((cert) => {
            const Icon = iconMap[cert.icon];
            const isExpanded = expandedId === cert.id;
            
            return (
              <div 
                key={cert.id} 
                className={`certification-card ${isExpanded ? 'expanded' : ''}`}
              >
                <button 
                  onClick={() => toggleExpand(cert.id)}
                  className="certification-header"
                >
                  <div className="certification-icon">
                    <Icon size={28} />
                  </div>
                  <div className="certification-info">
                    <h3 className="certification-name">{cert.name}</h3>
                    <span className="certification-year">{cert.year}</span>
                  </div>
                  <ChevronDown 
                    size={24} 
                    className={`chevron ${isExpanded ? 'rotated' : ''}`}
                  />
                </button>
                
                {isExpanded && (
                  <div className="certification-content">
                    <p className="certification-description">{cert.description}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="safety-cta-container">
          <button 
            onClick={() => setShowLeadPopup(true)}
            className="btn-primary safety-cta"
          >
            How to Choose Your Fit
          </button>
        </div>
      </div>

      {showLeadPopup && (
        <div className="lead-popup-overlay" onClick={() => setShowLeadPopup(false)}>
          <div className="lead-popup" onClick={(e) => e.stopPropagation()}>
            <button 
              className="lead-popup-close"
              onClick={() => setShowLeadPopup(false)}
            >
              ×
            </button>
            <h3 className="lead-popup-title">Get Your Perfect Fit Guide</h3>
            <p className="lead-popup-subtitle">
              Download our comprehensive guide on choosing the right gear for your riding style
            </p>
            <div className="lead-popup-form">
              <input 
                type="text" 
                placeholder="Your Name" 
                className="lead-input"
              />
              <input 
                type="email" 
                placeholder="Your Email" 
                className="lead-input"
              />
              <input 
                type="tel" 
                placeholder="Phone Number" 
                className="lead-input"
              />
              <button className="btn-primary" style={{ width: '100%' }}>
                Send Me The Guide
              </button>
            </div>
            <p className="lead-popup-note">
              *You'll also get early access notifications for new gear drops
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default SafetyLab;
